import { Translate } from "@/translations";

export const NoTerminals = () => {
  return (
    <div className="bg-grey1 z-10 flex h-full w-full items-center justify-center">
      <h1 className="font-signifier text-center text-3xl">
        <Translate
          i18nKey={"errors:noTerminals"}
          components={[<span className="text-carrot" />]}
        />
      </h1>
    </div>
  );
};

export default NoTerminals;
